import tick from '../helpers/async';
const UIController = {
  page: document.body.getAttribute('data-page'),
  init() {

    switch (this.page) {
      case 'home':
        this.initSlideshows();
        break;
      default:
        break;
    }

    this.initWatchers();

  },

  initWatchers() {
    const menuEl = document.getElementById('site-menu-button');
    menuEl && menuEl.addEventListener('click', this.handleMenuToggleClick);

    const langSelect = document.getElementById('language-selector-toggle');
    langSelect && langSelect.addEventListener('click', this.handleLangToggleClick)

    jQuery(".site-search").on('click', function () {
      jQuery(this).closest('.searchform').toggleClass('checked');
      console.log('updated');
    });
  },

  async handleMenuToggleClick() {
    const container = document.querySelector('.site-header');
    if (container.classList.contains('open')) {
      container.classList.remove('open');
    } else {
      container.classList.add('open');
      await tick(100);
      document.documentElement.addEventListener('click', this.autoCloseSiteMenu)
    }
  },
  async autoCloseSiteMenu(e) {
    if (e.target.getAttribute('id') === 'language-selector-toggle') {
      return;
    }
    await tick(100);
    const container = document.querySelector('.site-header');
    container.classList.remove('open');
    document.documentElement.removeEventListener('click', this.autoCloseSiteMenu);
  },

  async handleLangToggleClick() {
    const container = document.querySelector('.language-selector');
    if (container.classList.contains('open')) {
      container.classList.remove('open');
    } else {
      container.classList.add('open');
      await tick(100);
      document.documentElement.addEventListener('click', this.autoCloseLangMenu)
    }
  },
  async autoCloseLangMenu() {
    await tick(100);
    const container = document.querySelector('.language-selector');
    container.classList.remove('open');
    document.documentElement.removeEventListener('click', this.autoCloseLangMenu);
  },

  initSlideshows() {
    new Swiper('#home-hero-slider', {
      autoplay: {
        delay: 5000,
      }
      // direction: 'horizontal',
      // Optional parameters
      // loop: true,
      // Navigation arrows
      // parallax: true,
    });
  }


}

export default UIController;